export default __webpack_public_path__ + "static/media/menIcon.1de2d54c.svg";